import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Grid, Card, CardContent, Avatar } from '@mui/material';
import { Save, PieChart, Assessment, CheckCircle, Cancel } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../jsx/header';
import FlipCard from '../jsx/descriptionFlipcard';
import  '../css/ProjectDashboard.css';

const endpointpath = process.env.REACT_APP_API_BASE_URL;

export const Dashboard = () => {
  const [userData, setUserData] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [stats, setStats] = useState({
    savedProjects: 0,
    publishedProjects: 0,
    closedProjects: 0,
    cancelledProjects: 0,
    savedProposals: 0,
    submittedProposals: 0,
    applicationsAccepted: 0,
    applicationsRejected: 0,
  });
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
  
    if (!token) {
      console.log("No token in localStorage. Redirecting to /");
      navigate("/", { replace: true });
      return;
    }
  
    console.log("Token found in localStorage:", token);

    const fetchUserData = async () => {
      try {
        const response = await fetch(`${endpointpath}/api/user/data`, {
          headers: { authorization: token },
        });

        if (response.ok) {
          const data = await response.json();
          setUserData(data);
        } else {
          console.error('Failed to fetch user data');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    const fetchStats = async () => {
      try {
        const response = await fetch(`${endpointpath}/api/stats`, {
          method: 'GET',
          headers: { authorization: token },
        });
        if (response.ok) {
          const statsData = await response.json();
          setStats(statsData);
          console.log(statsData);
        } else {
          console.error('Failed to fetch project stats');
        }
      } catch (error) {
        console.error('Error fetching project stats:', error);
      }
    };

    fetchUserData();
    fetchStats();
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  const handleNewProjectClick = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  return (
    <>
    {/* <Header
      userData={userData}
      handleLogout={handleLogout}
      handleNewProjectClick={handleNewProjectClick}
      drawerOpen={drawerOpen}
      toggleDrawer={toggleDrawer}
    /> */}

    <Container style={{ marginTop: '80px' }}>
      <Box sx={{ mb: 4, textAlign: 'center', backgroundColor: '#f6f6f6', py: 3, borderRadius: 2 }}>
        <div className="heading-group">
          <h1>
            Welcome, {userData ? userData.Name.split(',')[1]?.trim().split(' ')[0] : 'User'}!
          </h1>
        </div>
      </Box>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <FlipCard />
        </Grid>
      </Grid>

      <Grid container spacing={4} sx={{ mt: 2 }}>
        {userData?.userType === 'Employer' ? (
          <>
            <Grid item xs={12} md={3}>
              <Card sx={{ textAlign: 'center', p: 2, backgroundColor: '#f6f6f6', minHeight: '120px' }}>
                <CardContent>
                  <Avatar sx={{ bgcolor: '#500000', m: '0 auto', mb: 1 }}>
                    <Save />
                  </Avatar>
                  <Typography variant="h6">{stats.savedProjects}</Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    Saved Projects
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ textAlign: 'center', p: 2, backgroundColor: '#f6f6f6', minHeight: '120px' }}>
                <CardContent>
                  <Avatar sx={{ bgcolor: '#732f2f', m: '0 auto', mb: 1 }}>
                    <PieChart />
                  </Avatar>
                  <Typography variant="h6">{stats.publishedProjects}</Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    Projects Published
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ textAlign: 'center', p: 2, backgroundColor: '#f6f6f6', minHeight: '120px' }}>
                <CardContent>
                  <Avatar sx={{ bgcolor: '#500000', m: '0 auto', mb: 1 }}>
                    <CheckCircle />
                  </Avatar>
                  <Typography variant="h6">{stats.closedProjects}</Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    Projects Closed
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ textAlign: 'center', p: 2, backgroundColor: '#f6f6f6', minHeight: '120px' }}>
                <CardContent>
                  <Avatar sx={{ bgcolor: '#3c0000', m: '0 auto', mb: 1 }}>
                    <Cancel />
                  </Avatar>
                  <Typography variant="h6">{stats.cancelledProjects}</Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    Projects Cancelled
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} md={3}>
              <Card sx={{ textAlign: 'center', p: 2, backgroundColor: '#f6f6f6', minHeight: '120px' }}>
                <CardContent>
                  <Avatar sx={{ bgcolor: '#500000', m: '0 auto', mb: 1 }}>
                    <Save />
                  </Avatar>
                  <Typography variant="h6" fontWeight="bold" color="#500000">{stats.savedProposals}</Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    Saved Proposals
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ textAlign: 'center', p: 2, backgroundColor: '#f6f6f6', minHeight: '120px' }}>
                <CardContent>
                  <Avatar sx={{ bgcolor: '#732f2f', m: '0 auto', mb: 1 }}>
                    <PieChart />
                  </Avatar>
                  <Typography variant="h6" fontWeight="bold" color="#500000">{stats.submittedProposals}</Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    Proposals Submitted
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ textAlign: 'center', p: 2, backgroundColor: '#f6f6f6', minHeight: '120px' }}>
                <CardContent>
                  <Avatar sx={{ bgcolor: '#732f2f', m: '0 auto', mb: 1 }}>
                    <CheckCircle />
                  </Avatar>
                  <Typography variant="h6" fontWeight="bold" color="#500000">{stats.applicationsAccepted}</Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    Applications Accepted
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ textAlign: 'center', p: 2, backgroundColor: '#f6f6f6', minHeight: '120px' }}>
                <CardContent>
                  <Avatar sx={{ bgcolor: '#3c0000', m: '0 auto', mb: 1 }}>
                    <Assessment />
                  </Avatar>
                  <Typography variant="h6" fontWeight="bold" color="#500000">{stats.applicationsRejected}</Typography>
                  <Typography variant="subtitle2" color="textSecondary">
                    Applications Rejected
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </>
        )}
      </Grid>
    </Container>
    </>
  );
};
